<app-monitor-layout #monitorContainer
  [test]="test"
  [testLoading]="testLoading$ | async"
  [patient]="patient"
  [bundle]="bundle"
  [screen]="currentDeviceScreen"
  [isTestDone]="isTestDone"
  [isTestSyncing]="isTestSyncing"
  [deviceLoading]="deviceLoading$ | async"
  [device]="device"
  [batteryPercentage]="batteryPercentage"
  [streamPopupVisible]="streamPopupVisible"
  [isSingleImage]="isSingleImage"
  [isV2Streaming]="isV2Streaming"
  [deviceActionLoading]="deviceActionLoading"
  [isLoading]="isLoading"
  [headsetAlignment]="headsetAlignment"
  (onClose)="close()"
  (onStreamOpen)="openStream($event)"
  (onStreamClose)="closeStream()"
  (onActionClicked)="onActionClicked($event)">

  <div class="monitor_container-column monitor_container-column--limit-height">
    @if (isOsEyeShown) {
      <div
        class="monitor_graph-box"
        [ngClass]="{ 'monitor_graph-box--single' : isSingleEyeTest }">
        @if (isTestSyncing || (osPhaseSyncing && !isTestDone)) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        @if (osPhaseSkipped) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text monitor_overlay-text--small">{{'skippedMessage' | translate}}</div></div>
        }
        <div class="monitor_graph-title">{{ 'left' | translate | titlecase }}</div>
        <app-skip-button
          class="monitor_graph-icon"
          [visible]="osPhaseSkippable"
          (onSkip)="onSkipEye('OS')">
        </app-skip-button>
        <div @startList class="monitor_list-container">
          @for (record of osData.slice().reverse(); track record; let i = $index) {
            <div
              @fadeAnimation
              class="monitor_list-item"
              [ngClass]="{'hidden': isOsRecordHidden(record, i)}">
              @if (record) {
                <ng-container *ngTemplateOutlet="recordView; context: { record: record }"></ng-container>
              } @else {
                <span class="text--blink">{{'syncing' | translate | titlecase}}...</span>
              }
            </div>
          }
          @if (!isLoading && !osData?.length) {
            <small>{{ isTestDone ? ('noTestDataReceived' | translate) : ('noTestData' | translate) }}</small>
          }
        </div>
      </div>
    }
    @if (isOdEyeShown) {
      <div
        class="monitor_graph-box"
        [ngClass]="{ 'monitor_graph-box--single' : isSingleEyeTest }">
        @if (isTestSyncing || (odPhaseSyncing && !isTestDone)) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        @if (odPhaseSkipped) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text monitor_overlay-text--small">{{'skippedMessage' | translate}}</div></div>
        }
        <div class="monitor_graph-title">{{ 'right' | translate | titlecase }}</div>
        <app-skip-button
          class="monitor_graph-icon"
          [visible]="odPhaseSkippable"
          (onSkip)="onSkipEye('OD')">
        </app-skip-button>
        <div @startList class="monitor_list-container">
          @for (record of odData.slice().reverse(); track record; let i = $index) {
            <div
              @fadeAnimation
              class="monitor_list-item"
              [ngClass]="{'hidden': record && record.threshold && record.seq_num}">
              @if (record) {
                <ng-container *ngTemplateOutlet="recordView; context: { record: record }"></ng-container>
              } @else {
                <span class="text--blink">{{'syncing' | translate | titlecase}}...</span>
              }
            </div>
          }
          @if (!isLoading && !odData?.length) {
            <small>{{ isTestDone ? ('noTestDataReceived' | translate) : ('noTestData' | translate) }}</small>
          }
        </div>
      </div>
    }
    @if (isOuOnlyTest) {
      <ng-container *ngTemplateOutlet="ouSection; context: { single: true }"></ng-container>
    }
  </div>

  <div class="monitor_container-column monitor_container-column--limit-height">
    @if (!isInsideCSuite && !isSingleEyeTest && !isOuOnlyTest) {
      <ng-container *ngTemplateOutlet="ouSection; context: { single: false }"></ng-container>
    }
    <div
      class="monitor_graph-box"
      [ngClass]="{ 'monitor_graph-box--single' : isInsideCSuite || isSingleEyeTest || isOuOnlyTest }">
      @if (isTestSyncing) {
        <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
      }
      <app-percentage-circle
        id="test-percentage"
        class="monitor_circle-box"
        [percentage]="getPercentageDone()">
      </app-percentage-circle>
    </div>
  </div>
</app-monitor-layout>

<ng-template #ouSection let-single="single">
  <div
    class="monitor_graph-box"
    [ngClass]="{ 'monitor_graph-box--single' : single }">
    @if (isTestSyncing) {
      <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
    }
    @if (ouPhaseSkipped) {
      <div class="monitor_sync-box"><div class="monitor_overlay-text monitor_overlay-text--small">{{'skippedMessage' | translate}}</div></div>
    }
    <div class="monitor_graph-title">{{ 'both' | translate | titlecase }}</div>
    <app-skip-button
      class="monitor_graph-icon"
      [visible]="ouPhaseSkippable"
      (onSkip)="onSkipEye(null)">
    </app-skip-button>
    <div @startList class="monitor_list-container">
      @for (record of ouData.slice().reverse(); track record; let i = $index) {
        <div
          @fadeAnimation
          class="monitor_list-item"
          [ngClass]="{'hidden': isOuRecordHidden(record, i)}">
          @if (record) {
            <ng-container *ngTemplateOutlet="recordView; context: { record: record }"></ng-container>
          } @else {
            <span class="text--blink">{{'syncing' | translate | titlecase}}...</span>
          }
        </div>
      }
      @if (!isLoading && !ouData?.length) {
        <small>{{ isTestDone ? ('noTestDataReceived' | translate) : ('noTestData' | translate) }}</small>
      }
    </div>
  </div>
</ng-template>

<ng-template #recordView let-record="record">
  <i class="fas fa-eye" [ngClass]="{ 'orange': !record?.viewed, 'color-primary': record?.viewed }"></i>
  <span
    matTooltip="{{ isContrastTest ? ('contrast' | translate | titlecase) : ('size' | translate | titlecase) }}"
    class="pointer">
    {{ isContrastTest ? (record?.contrast + '&#37;') : ((record?.version > 1) ? record?.size_label : record?.size) }}
  </span>

  @if (record?.direction) {
    <app-direction-arrow
      matTooltip="{{ 'direction' | translate | titlecase }}"
      class="monitor_list-arrow"
      [direction]="record?.direction"
      [viewed]="record?.viewed">
    </app-direction-arrow>
  }

  <span>
    {{ record?.viewed ? ('seen' | translate) : ('unseen' | translate) }}
  </span>
</ng-template>
